import 'angular';

import { ProlinkSettingsCtrl } from './prolink.settings';
import { PROLinkEvents }       from './prolink.events.service';
import { PROLinkInvoices }     from './prolink.invoices.service';
import { PROLinkOrders }       from './prolink.orders.service';
import { ProlinkStates }       from './prolink.states.ajs';

angular.module('workshop.prolink', [])

.controller('ProlinkSettingsCtrl',  ProlinkSettingsCtrl)

.factory('PROLinkEvents',   PROLinkEvents)
.factory('PROLinkInvoices', PROLinkInvoices)
.factory('PROLinkOrders',   PROLinkOrders)

.config(ProlinkStates);